import {
  Directive,
  ElementRef,
  OnInit,
  inject
} from '@angular/core';
import { NgrxFormControlDirective } from 'ngrx-forms';

// TODO: form state interfaces
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[zefFormElement], [matInput]',
  standalone: false
})
export class ZefFormElementDirective implements OnInit {

  #ngrxFormControlRef = inject(NgrxFormControlDirective<any>, { optional: true });
  #elementRef = inject(ElementRef);

  elRef: ElementRef;

  ngOnInit() {
    this.elRef = this.#elementRef;
  }

  getState() {
    return this.#ngrxFormControlRef
      ? this.#ngrxFormControlRef.state
      : undefined;
  }
}
